import { useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import PropertiesTabs from './PropertiesTabs';
import { useSelector } from 'react-redux';
import { RootState } from 'slices/store';
import { getPaymentListingByUserId } from 'endpoints/users/userDetailPage.action';
import { useQuery } from '@tanstack/react-query';
import PaymentsListing from './PaymentsListings';
import DocumentsListing from './DocumentsListing';
import { documentsListingData } from 'common/data/users';


const UserNavTabs = () => {
    const [activeTab, setActiveTab] = useState('properties');
    const [currentPaymentPage, setCurrentPaymentPage] = useState(1);
    const [limit] = useState(10);

    // Get user ID from Redux store
    const userId = useSelector((state: RootState) => state.User.selectedUserId);

    const {
        data: paymentsResponse,
        isLoading: isPaymentsLoading,
        isError: isPaymentsError,
        refetch: refetchPayments,
        isRefetching: isPaymentsRefetching
    } = useQuery({
        queryKey: ['paymentDetailsByUser', userId],
        queryFn: () => getPaymentListingByUserId({
            id: userId,
            page: currentPaymentPage,
            limit: limit
        }),
        enabled: !!userId && activeTab === 'Payments',
        staleTime: 0,
        gcTime: 0,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        refetchOnReconnect: true,
        retry: 3,
    });

    const paymentsData = paymentsResponse?.data || [];
    const paymentsTotalCount = paymentsData?.data?.total || 0;
    const paymentsTotalPages = Math.ceil(paymentsTotalCount / limit);

    const handlePaymentPageChange = (page: number) => {
        setCurrentPaymentPage(page);
    };

    const handleTabChange = (tab: string) => {
        setActiveTab(tab);
        // Reset pagination when switching tabs
        if (tab === 'Payments') {
            setCurrentPaymentPage(1);
        }
    };

    return (
        <div>
            <Nav pills className="nav-success mt-4 mb-4">
                <NavItem>
                    <NavLink
                        active={activeTab === 'properties'}
                        onClick={() => handleTabChange('properties')}
                        style={{ cursor: 'pointer' }}
                    >
                        Properties
                    </NavLink>
                </NavItem>
                {/* <NavItem>
                    <NavLink
                        active={activeTab === 'documents'}
                        onClick={() => handleTabChange('documents')}
                        style={{ cursor: 'pointer' }}
                    >
                        Documents
                    </NavLink>
                </NavItem> */}
                <NavItem>
                    <NavLink
                        active={activeTab === 'Payments'}
                        onClick={() => handleTabChange('Payments')}
                        style={{ cursor: 'pointer' }}
                    >
                        Payments
                    </NavLink>
                </NavItem>
            </Nav>

            {activeTab === 'properties' && <PropertiesTabs />}
            {activeTab === 'documents' && <DocumentsListing documentsListingData={documentsListingData} loading={false}/>}
            {activeTab === 'Payments' && (
                <PaymentsListing
                    data={paymentsData}
                    loading={isPaymentsLoading}
                    isError={isPaymentsError}
                    onRefresh={refetchPayments}
                    currentPage={currentPaymentPage}
                    totalPages={paymentsTotalPages}
                    totalCount={paymentsTotalCount}
                    onPageChange={handlePaymentPageChange}
                    isRefetching={isPaymentsRefetching}
                />
            )}
        </div>
    );
};

export default UserNavTabs;
